import React from 'react';

const SelectOption = ({ selectedOptions, option, onChange, classes = '' }) => {
  const optionId = `product-option-${option.name}`;

  return (
    <div className={classes}>
      <label
        htmlFor={optionId}
        className="body-2 mb-2 block"
      >
        {option.name}
      </label>
      <select
        id={optionId}
        name={optionId}
        className="mt-1 block w-full border-gray-300 py-2 pl-3 pr-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
        onChange={(e) => onChange(option, e.target.value)}
        data-option-name={option.name}
      >
        {option.values.map((value) => (
          <option
            key={`${optionId}-${value}`}
            value={value}
            selected={selectedOptions.find((o) => o.name === option.name && o.value === value)}
          >
            {value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectOption;
